import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { isEmpty, isLoaded, useFirestoreConnect } from "react-redux-firebase";
import { Link, Redirect } from "react-router-dom";
import LoadingIndicator from "../../../components/common/LoadingIndicator";
import UpdateItemForm from "../../../components/forms/menu/UpdateItemForm";
import { ADMIN_MENU_PATH } from "../../../constants/paths";
import {
  deleteProduct,
  resetDelete,
} from "../../../store/actions/RestaurantActions";

import MdTrash from "react-ionicons/lib/MdTrash";
import ModalDelete from "../../../components/common/ModalDelete";
import ModalLoading from "../../../components/common/ModalLoading";
import BackButton from "../../../components/common/BackButton";

const ProductPage = ({
  match,
  deleteProduct,
  loading,
  success,
  error,
  resetDelete,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const productName = `section-${match.params.section_id}-product-${match.params.product_id}`;

  useFirestoreConnect([
    {
      collection: "categories",
      doc: match.params.section_id,
      subcollections: [
        { collection: "products", doc: match.params.product_id },
      ],
      storeAs: productName,
    },
  ]);

  const product = useSelector(({ firestore }) => {
    const product = firestore.data[productName];
    return product
      ? product.Toppings
        ? {
            ...product,
            extras: Object.keys(product.Toppings)
              .sort((a, b) => {
                return product.Toppings[a].order - product.Toppings[b].order;
              })
              .map((key) => {
                const toppingsData = product.Toppings[key];
                const options = toppingsData.products
                  ? toppingsData.products
                  : {};

                return {
                  title: key,
                  ...toppingsData,
                  options: Object.keys(options)
                    .sort((a, b) => {
                      return options[a].order - options[b].order;
                    })
                    .map((key) => {
                      return { title: key, price: options[key].price };
                    }),
                };
              }),
          }
        : { ...firestore.data[productName], extras: [] }
      : {};
  });

  const handleDelete = () => {
    closeModal();
    deleteProduct(match.params.product_id, match.params.section_id);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  if (!isLoaded(product)) return <LoadingIndicator />;

  if (success) {
    resetDelete();
    return (
      <Redirect to={`${ADMIN_MENU_PATH}/seccion/${match.params.section_id}`} />
    );
  }

  if (isLoaded(product) && isEmpty(product)) return <LoadingIndicator />;

  return (
    <div className="px-16 py-8 text-gray-900">
      <ModalLoading
        message="Se están realizando los cambios en la base de datos. Espere un momento por favor."
        closeModal={null}
        modalIsOpen={loading}
        shouldCloseOnEsc={false}
        shouldCloseOnOverlayClick={false}
        subtitle=""
        title="Modificando datos"
        loading
      ></ModalLoading>
      <ModalDelete
        message="¿Estás seguro que quieres borrar los datos del producto?
                    Todos los datos serán perdidos permanentemente. Esta acción
                    no se puede revertir."
        closeModal={closeModal}
        modalIsOpen={isModalOpen}
        shouldCloseOnEsc
        shouldCloseOnOverlayClick
        subtitle={product.title}
        title="Borrar producto"
        remove={handleDelete}
      ></ModalDelete>
      <BackButton />
      <div className="bg-white mt-4 shadow-sm border rounded-sm">
        <p className="px-6 py-3 border-b flex justify-between">
          {product.title}
          <MdTrash onClick={openModal}></MdTrash>
        </p>
        <div className="bg-gray-100 px-6 py-3 relative text-gray-700 text-md">
          <div className="menu">
            <UpdateItemForm
              {...product}
              imageUrl={product.image}
              id={match.params.product_id}
              sectionId={match.params.section_id}
            ></UpdateItemForm>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return { ...state.restaurant.productActions.delete };
};

const mapDispatchToProps = (dispatch) => {
  return {
    deleteProduct: (id, sectionId) => dispatch(deleteProduct(id, sectionId)),
    resetDelete: () => {
      dispatch(resetDelete());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductPage);
